"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.render = function () {
        var _a = this.props, itemCount = _a.itemCount, itemSize = _a.itemSize;
        var height = itemCount * itemSize;
        var paddingTop = this.firstVisibleItemIndex * itemSize;
        return (react_1.default.createElement("div", { className: "list", style: {
                height: height,
                paddingTop: paddingTop,
            } }, this.renderItems()));
    };
    List.prototype.renderItems = function () {
        var _a = this.props, renderItem = _a.renderItem, itemCount = _a.itemCount;
        var items = [];
        for (var i = 0; i < this.visibleItemsPerPage; ++i) {
            var index = this.firstVisibleItemIndex + i;
            if (index >= itemCount) {
                break;
            }
            items.push(renderItem(index));
        }
        return items;
    };
    Object.defineProperty(List.prototype, "firstVisibleItemIndex", {
        get: function () {
            var _a = this.props, scrollPosition = _a.scrollPosition, itemSize = _a.itemSize;
            return Math.floor(scrollPosition / itemSize);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(List.prototype, "visibleItemsPerPage", {
        get: function () {
            var _a = this.props, containerSize = _a.containerSize, itemSize = _a.itemSize;
            return Math.ceil(containerSize / itemSize) + 1;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], List.prototype, "firstVisibleItemIndex", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], List.prototype, "visibleItemsPerPage", null);
    List = __decorate([
        mobx_react_1.observer
    ], List);
    return List;
}(react_1.default.Component));
exports.List = List;
